import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useComponentDidMount from 'Hooks/useComponentDidMount';

const NavigateToPage = () => {
  const { modalCollection, clearModalCollection } = useModalContext();
  const { setPageContentCollection } = usePageContentContext();

  useComponentDidMount(() => {
    setPageContentCollection(modalCollection);
    clearModalCollection();
  });

  return <React.Fragment />;
};

export default NavigateToPage;
